import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Box } from "@mui/material";
import { ReactNode } from "react";

interface ModalConfirmSelectProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void | Promise<void>;
	title?: string;
	description?: string;
	confirmLabel?: string;
	cancelLabel?: string;
	customContent?: ReactNode;
	isLoading?: boolean;
	disabledConfirmButton?: boolean;
}

export const ModalConfirmSelect = ({
	open,
	onClose,
	onConfirm,
	title = "Confirmação",
	description = "Deseja realmente executar esta ação?",
	confirmLabel = "Confirmar",
	cancelLabel = "Cancelar",
	customContent,
	isLoading = false,
	disabledConfirmButton,
}: ModalConfirmSelectProps) => {
	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent dividers>
				{description && <DialogContentText sx={{ mb: 2 }}>{description}</DialogContentText>}

				{/* Conteúdo extra configurável */}
				{customContent && <Box mt={1}>{customContent}</Box>}
			</DialogContent>

			<DialogActions>
				<Button onClick={onClose} disabled={isLoading}>
					{cancelLabel}
				</Button>
				<Button variant="contained" color="primary" onClick={onConfirm} disabled={disabledConfirmButton || isLoading}>
					{confirmLabel}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
